import { useEffect, useState } from "react";
import { getImageFirebase } from "./getImageFirebase";

export default function FirebaseImage({ location, alt = "Image", style }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!location) return;
    getImageFirebase(location).then(setUrl).catch(console.error);
  }, [location]);

  if (!location) return <span>No image</span>;
  if (!url) return <span>Loading...</span>;

  return (
    <img
      src={url}
      alt={alt}
      style={{
        width: "3rem",
        height: "3rem",
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  );
}
